import React from 'react'
import {useSelector} from 'react-redux'
import styled from '@emotion/styled'
import {getLanguageCode} from 'modules/meta/selectors'

import {Box} from '@vio/atlas/helpers/Box'
import {cssTheme} from '@vio/atlas/themes'
import {TrustPilotWidgetTheme} from '@vio/shared/src/search/TrustpilotWidget'

import {AppRatingsAndReviews} from '../AppRatingsAndReviews'
import {TrustpilotDetails} from '../TrustpilotDetails'

const VerticalDivider = styled.div`
  background-color: ${cssTheme.colors.border.neutral.secondary};
  height: 24px;
  width: 1px;
`

const VioWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: ${cssTheme.layout.spacing.s900};
  padding: ${cssTheme.layout.spacing.s500};
  background-color: ${cssTheme.colors.background.neutral.primary};
  border-top-right-radius: ${cssTheme.layout.radius.xl};
  border-top-left-radius: ${cssTheme.layout.radius.xl};
`

interface Props {
  trustPilotTheme?: TrustPilotWidgetTheme
  isVioBrand?: boolean
  className?: string
}

export const SocialProof: React.FC<Props> = ({
  trustPilotTheme,
  isVioBrand,
  className
}) => {
  const languageCode = useSelector(getLanguageCode)

  if (isVioBrand) {
    return (
      <VioWrapper className={className}>
        <AppRatingsAndReviews
          variant="AppStore"
          redirectLanguage={languageCode}
        />
        <TrustpilotDetails section="Hero" trustPilotTheme={trustPilotTheme} />
        <AppRatingsAndReviews
          variant="GooglePlay"
          redirectLanguage={languageCode}
        />
      </VioWrapper>
    )
  }
  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      gap="s800"
      paddingTop="s500"
      className={className}
    >
      <AppRatingsAndReviews
        variant="AppStore"
        redirectLanguage={languageCode}
      />
      <VerticalDivider />
      <TrustpilotDetails section="Hero" trustPilotTheme={trustPilotTheme} />
      <VerticalDivider />
      <AppRatingsAndReviews
        variant="GooglePlay"
        redirectLanguage={languageCode}
      />
    </Box>
  )
}
